var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron Down",
    clipPath: "url(#clip0_60_16097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M17.998 13.1244C17.9968 13.3781 17.9205 13.6257 17.7788 13.836C17.637 14.0464 17.4361 14.21 17.2014 14.3063C16.9667 14.4025 16.7088 14.4271 16.4602 14.377C16.2115 14.3268 15.9833 14.2041 15.8043 14.0244L8.99804 7.22718L2.19404 14.0357C1.95017 14.2646 1.62678 14.3897 1.29231 14.3845C0.957844 14.3792 0.638552 14.244 0.402018 14.0074C0.165483 13.7709 0.0302734 13.4516 0.0250052 13.1172C0.0197371 12.7827 0.144823 12.4593 0.373789 12.2154L8.99804 3.59118L17.6245 12.2154C17.7435 12.3349 17.8377 12.4768 17.9018 12.6327C17.9659 12.7887 17.9986 12.9558 17.998 13.1244Z",
    fill: "#455A64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_16097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(18 18) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.3b4c6d5be9f0d34a57d5bf25ba90672c.svg";
export { ForwardRef as ReactComponent };